export default "__VITE_ASSET__DJ52O2EZ__"